import { render, staticRenderFns } from "./EvaluationsOfMyTeam.vue?vue&type=template&id=3704b0ab"
import script from "./EvaluationsOfMyTeam.vue?vue&type=script&lang=js"
export * from "./EvaluationsOfMyTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports